export default __webpack_public_path__ + "static/media/instagram.02967a62.svg";